import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import { toast } from "react-toastify";

import { ComponentStatus } from "../../components";
import { getToken } from "../../shared/utils/LocalSessionHandler";
import { SessionService } from "../../services";
import {
    BackImgContainer,
    WhiteTableContainer,
} from "../../components/Containers";
import { JumpBtn } from "../../components/Buttons";
import { ThisPaths } from "../../shared/Constants";
import { PasswordInput } from "../../components/Inputs";
import {
    useFormInput,
    useWindowDimension,
} from "../../shared/utils/CustomHooks";
import { MainLogo, UserSessionSpan } from "./MainLogo";
import { IState } from "../../app-state/reducer";
import { Session } from "../../models";
import { Actions } from "../../app-state/actions";

interface IChangePassword extends RouteComponentProps {
    isActivateAccount?: boolean;
}
const ChangePassword: React.FC<IChangePassword> = ({
    history,
    isActivateAccount,
}) => {
    const currentPass = useFormInput("");
    const passwordFirst = useFormInput("");
    const passwordSecond = useFormInput("");
    const [error, setError] = useState<string>("");
    const [status, setStatus] = useState<ComponentStatus>("complete");
    const dimensions = useWindowDimension();
    const dispatch = useDispatch();
    const session = useSelector<IState, Session | undefined>(
        (state) => state.session
    );

    const checkPassword = (): boolean => {
        if (!currentPass.value && !isActivateAccount) {
            setError("Ingrese su contraseña actual.");
            setStatus("errored");
            return false;
        }

        if (passwordFirst.value.length < 6) {
            setError("Las contraseña debe poseer al menos 6 digitos.");
            setStatus("errored");
            return false;
        }

        /*const regex =
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
        if (!passwordFirst.value.match(regex)) {
            setError("La contraseña no cumple con los requisitos.");
            setStatus("errored");
            return false;
        }*/

        if (
            passwordFirst.value.toLowerCase() !==
            passwordSecond.value.toLowerCase()
        ) {
            setError("Las contraseñas no coinciden.");
            setStatus("errored");
            return false;
        }

        return true;
    };

    const handleActivateAccount = async () => {
        const urlParams = new URLSearchParams(window.location.search);
        const tokenQuery = urlParams.get("key") || "";
        setStatus("loading");
        if (checkPassword()) {
            const sr = await SessionService.ActivateAccount({
                token: tokenQuery,
                password: passwordFirst.value,
            });

            if (sr.status()) {
                toast.success("Activación exitosa!!");
                history.push(ThisPaths.LOGIN);
            } else {
                setStatus("errored");
                setError(sr.getParsedError());
            }
        }
    };

    const handleAction = async () => {
        if (isActivateAccount) return handleActivateAccount();

        setStatus("loading");

        // check pass word already handles status
        if (checkPassword()) {
            const token = getToken();
            const sr = await SessionService.ChangePassword({
                token: token!,
                userId: session!.user.userId,
                currentPassword: currentPass.value,
                password: passwordFirst.value,
            });

            if (sr.status()) {
                dispatch(Actions.RESET_STATE());
                toast.success("Cambio de clave exitoso!!");
                history.push(ThisPaths.LOGIN);
            } else {
                setStatus("errored");
                setError(sr.getParsedError());
            }
        }
    };

    return (
        <BackImgContainer
            disabledImg={window.innerWidth < 1000}
            inActiveHeader={isActivateAccount}
        >
            <WhiteTableContainer
                style={
                    dimensions.height <= 667
                        ? { height: (dimensions.height * 70) / 100 }
                        : undefined
                }
            >
                {isActivateAccount && <MainLogo />}
                <UserSessionSpan>
                    Ingrese una contraseña de al menos 6 digitos.
                </UserSessionSpan>
                {!isActivateAccount && (
                    <PasswordInput
                        {...currentPass}
                        placeholder="Contraseña actual"
                        style={{ margin: "4%" }}
                    />
                )}
                <PasswordInput
                    {...passwordFirst}
                    placeholder="Nueva Contraseña"
                    style={{ margin: "4%" }}
                />
                <PasswordInput
                    {...passwordSecond}
                    placeholder="Confirmar Contraseña"
                    style={{ margin: "4%" }}
                />
                {status === "errored" && (
                    <>
                        <small
                            style={{
                                color: "red",
                                width: "85%",
                                wordWrap: "break-word",
                            }}
                        >
                            {error}
                        </small>
                        <br />
                    </>
                )}
                <JumpBtn
                    borderColor={"#ef3c34"}
                    colorOnHover={"#0053a0"}
                    value={
                        status === "loading"
                            ? "Cargando..."
                            : isActivateAccount
                            ? "Activar cuenta"
                            : "Cambiar contraseña"
                    }
                    onClick={handleAction}
                    disabled={status === "loading"}
                />
            </WhiteTableContainer>
        </BackImgContainer>
    );
};

export default ChangePassword;
